const graphQlErrors = (err) => {
  const errors = err.graphQLErrors || null;
  return {
    fieldErrors() {
      if (!errors) return null;

      const fieldErrors = errors.filter((error) => (
        error.extensions.response
          && typeof error.extensions.response.body.fieldErrors !== 'undefined'
      ))[0];

      return fieldErrors ? fieldErrors.extensions.response.body.fieldErrors : null;
    },
    logicErrors() {
      if (!errors) return null;

      const logicErrors = errors.filter((error) => (
        error.extensions.response
          && typeof error.extensions.response.body.error !== 'undefined'
      ));

      return logicErrors.length > 0
        ? logicErrors.map((error) => error.extensions.response.body.error)
        : null;
    },
  };
};

module.exports = graphQlErrors;
